import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { results } from '@mdc/ui';
import { useTranslation } from 'react-i18next';
import MUTEX_DATA from './MutexData';
import StackTable from '../../dynamic-analysis/StackTable';

import './Mutex.scss';

const { SandboxScore, PlainTablePlaceholder, SandboxTabs } = results;

const Mutex = ({ sandboxResults, resultsLoading, scanning, fileImage }) => {
    const { t, ready } = useTranslation();

    const mutexName = useMemo(() => ([
        { key: 'mutant', name: t('Mutant') },
        { key: 'event', name: t('Event') }
    ]), [t]);

    const processRawData = (data, meta) => meta.filter((row) => Object.hasOwnProperty.call(data, row.accessor) && (data[row.accessor] || typeof data[row.accessor] === 'number'))
        .map((row) => {
            let value = row.parser ? row.parser(data[row.accessor]) : data[row.accessor];
            return { field: row.header, data: value };
        });

    const mutexDetails = useMemo(() => sandboxResults?.data?.details?.data?.mutex, [sandboxResults]);

    const tableData = useMemo(() => {
        if (mutexDetails) {
            const meta = MUTEX_DATA(t);

            return mutexDetails.map((detail) => {
                const title = mutexName.find((net) => detail.n.includes(net.key))?.name;
                const data = processRawData(detail.d, meta);
                data.title = title;
                return data;
            });
        }
    }, [mutexDetails, mutexName, t]);

    const aboutDynamicAnalysisDom = useMemo(() => <>
        {/*eslint-disable-next-line no-useless-escape*/}
        <p className='aboutDynamicAnalysis' dangerouslySetInnerHTML={{ __html: t('Read more about dynamic analysis on our <a href=\"https://onlinehelp.opswat.com/mdcloud/4._Dynamic_analysis.html\" target=\"_blank\">Documentation</a> page') }}/>
    </>, [t]);

    const dynamicAnalysisDom = useMemo(() => {
        if (!tableData) {
            return <PlainTablePlaceholder numberOfColumns={6}/>;
        }

        return <StackTable
            data={tableData}
        />;
    }, [tableData]);

    if (!ready) {
        return null;
    }

    return <SandboxTabs className='sandboxMutexSection dynamicAnalysis' isNoData={sandboxResults?.data && !mutexDetails?.length}>
        <Row>
            <Col lg={3} md={3} xs={12}>
                <SandboxScore
                    category={t('Mutex')}
                    resultsLoading={resultsLoading}
                    scanning={scanning}
                    sandboxResults={sandboxResults}
                    fileImage={fileImage}
                />
                {aboutDynamicAnalysisDom}
            </Col>

            <Col lg={9} md={9} xs={12} className='mutexDataWrapper'>
                {dynamicAnalysisDom}
            </Col>
        </Row>
    </SandboxTabs>;
};

Mutex.propTypes = {
    resultsLoading: PropTypes.bool,
    scanning: PropTypes.string,
    sandboxResults: PropTypes.object,
    fileImage: PropTypes.object.isRequired
};

export default Mutex;
